/*
 * @Author: tianzhitong laotianwy@163.com
 * @Date: 2024-04-12 10:02:31
 * @LastEditors: tianzhitong laotianwy@163.com
 * @LastEditTime: 2024-04-29 22:08:45
 * @FilePath: /seller-station-client/src/config/router/biz/mall.tsx
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
import { NestedRoute, Route } from '@sniff/routeguard';
import { Content } from 'antd/es/layout/layout';
import { lazy } from 'react';
import MallLayout from '@route/mall/_layout';
import HomeIndex from '@route/mall/home/Index';
import VipIndex from '@route/mall/vip/Index';
import cart from './cart';

const mall: Route = {
	path: '',
	id: 'mall',
	component: MallLayout,
	children: [
		{
			path: '',
			id: 'home_index',
			component: HomeIndex,
			meta: {
				title: 'Home'
			}
		},
		{
			path: 'vip',
			id: 'vip_index',
			component: VipIndex,
			meta: {
				title: 'VIP'
			}
		},
		{
			path: 'source',
			id: 'source_index',
			component: lazy(() => import('@route/mall/goods/Source')),
			meta: {
				title: 'Source'
			}
		},
		{
			path: 'category',
			id: 'category_index',
			component: lazy(() => import('@route/mall/goods/MoreHotList')),
			meta: {
				title: 'Category'
			}
		},
		{
			path: 'search',
			id: 'search_index',
			component: lazy(() => import('@route/mall/goods/SearchList')),
			meta: {
				title: 'Search'
			}
		},
		{
			path: 'tiktokList',
			id: 'tiktokList_index',
			component: lazy(() => import('@route/mall/goods/TikTokCateList')),
			meta: {
				title: 'TiktokList'
			}
		},
		{
			path: 'sameList',
			id: 'same_list_index',
			component: lazy(() => import('@route/mall/goods/HotProductList')),
			meta: {
				title: 'SameList'
			}
		},
		{
			path: 'goods',
			id: 'goods',
			component: () => (
				<>
					<Content className="w-[100%] bg-[#fff] flex flex-col m-auto">
						<NestedRoute />
					</Content>
				</>
			),

			children: [
				{
					path: ':productCode',
					id: 'goods-productCode',
					component: lazy(() => import('@route/mall/goods/Detail'))
				}
			]
		},
		cart
	]
};

export default mall;
